import type { NotificationObservationCommentedCardProps } from "./notification-observation-commented-card.type";

import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import { CommentLink } from "@/modules/comment/comment-link";
import ModelIcon from "@/modules/model-icon";
import { NotificationCard } from "@/modules/notification/notification-card";
import { useNotificationsPanel } from "@/modules/notifications/notifications-panel";

const { Paragraph } = Typography;

export const NotificationObservationCommentedCard = ({
  notification,
}: NotificationObservationCommentedCardProps) => {
  const { t } = useTranslation();
  const { closePanel } = useNotificationsPanel();

  const { comment, intervention, observation } = notification.data;
  const color = "var(--app-color-info)";

  return (
    <NotificationCard
      notification={notification}
      icon={<ModelIcon model="comment" style={{ color }} />}
      title={t("notification:observationCommented.title")}
      color={color}
      subTitle={comment.author_name}
      content={<Paragraph ellipsis={{ rows: 2 }}>{comment.content}</Paragraph>}
      actions={
        <CommentLink
          intervention={intervention}
          observation={observation}
          showIcon="external"
          customModel={undefined}
          onClick={closePanel}
        />
      }
    />
  );
};
